/**
 * Skip-tool-authorization ("dangerously skip permissions") toggle — client read side.
 *
 * The toggle's state is DURABLE project state (`settings.approvals.behavior`), changed server-side by
 * the customer control-plane op behind `maxService.setToolAuthorizationBehavior(...)` (no turn, no
 * conversation). The client reads its position from the project state here. There is no client-built
 * content block: the flip is a direct MCP operation, not a `sendMessage` submission.
 */
import { ToolAuthorizationBehavior, type ProjectState } from "@amzn/awsmp-max-model";

/**
 * Whether tool authorization is being skipped, read from the durable project setting
 * (`settings.approvals.behavior === ToolAuthorizationBehavior.Skip`), defaulting to off. This is the same
 * value the server's authorization gate reads, so the toggle's position always matches what the gate
 * will do.
 */
export function isSkipToolAuthorizationEnabled(state: ProjectState | null | undefined): boolean {
  return state?.settings?.approvals?.behavior === ToolAuthorizationBehavior.Skip;
}
